<template>
  <div class="custom-checkbox" :class="[theme]">
        <input type="checkbox" :name="name" :class="className" :id="id" :value="value" :checked="checked" :required="required" @change="updateInput">
        <label v-bind:for="id">
          <slot></slot>
      </label>
  </div>
</template>

<script>
export default {
  props: {
      theme: {
        type: String,
        required: false
      },
      name: {
        type: String,
        required: false
      },
      className: {
        type: String,
        required: false
      },
      id: {
        type: String,
        required: false
      },
      value: {
        type: String,
        required: false
      },
      required: {
        type: Boolean,
        required: false,
        default: false
      },
      checked: {
        type: Boolean,
        required: false,
        default: false
      },
      inverted: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    methods: {
      updateInput: function(event) {
        this.$emit('input', event.target.checked);
      }
    },
    data () {
      return {

      }
    }
}
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";

.custom-checkbox {
    display: flex;
    align-items: flex-start;

  input[type=checkbox], input[type=radio], label {
    user-select: none;
    font-size: 1.2em;
    font-weight: 700;
    cursor: pointer;
    line-height: 1.9em;
  }
  input[type=checkbox], input[type=radio] {
    position: relative;
    border: 1px solid #000000;
    margin: .5em .5em 0em 0em;
    padding: 0;
    text-align: center;
    width: 1em;
    height: 1em;
    min-width: 1em;
    min-height: 1em;
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    border-radius: 0;
    color: rgba(white, 0);
    transition: all 0.2s ease;
    &:before {
      content: "";
      position: absolute;
      left: 20%;
      top: 20%;
      width: 60%;
      height: 60%;
      border-radius: 13%;
    }
    &:focus {
      outline: 0;
      &:before{
        background-color: $grey-fill;
      }
    }
    &:active {
      outline: none;
      &:before{
        background-color: $red-fill;
      }
    }
    &:hover {
      outline: none;
      &:before{
        background-color: $grey-fill;
      }
    }
    &:checked {
      color: black;
      &:before{
        background-color: $red-fill;
      }
    }
  }
  &.lightGrey {
    input[type=checkbox], input[type=radio] {
      border: 1px solid $grey-border;
      border-radius: 5px;
    }
  }
  &.inverted {
    input[type=checkbox], input[type=radio] {
      border: 1px solid black;
      &:focus {

      }
      &:checked {
        background: black;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/Checkbox.vue